module.exports = __webpack_public_path__ + "img/img31.867bc3fa.svg";